import { Link } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import config from 'config';
// import Logo from 'ui-component/Logo';
import LogoSahmain from 'assets/images/logo/icon-wide-32.jpg';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => (
    <ButtonBase disableRipple component={Link} to={config.defaultPath}>
        <img src={LogoSahmain} alt="sahmain-logo" width="100%" />
    </ButtonBase>
);

export default LogoSection;
